import React from "react";
import { BaseField } from "../BaseField";
import { Configurable } from "./Configurable";
import { AppearanceCheckbox } from "./fields/AppearanceCheckbox";

export class HideInPdf extends Configurable {
    public schema;
    public designer;
    public field;
    public defaultValue = false;

    public keyName = "hideInPdf";
    public title = "Im PDF ausblenden";
    public description =
        "Das gesamte Feld erscheint nicht im PDF-Protokoll. In App und Web bleibt es sichtbar.";
    public value = "";

    public EditComponent({
        register,
        schema,
        designer,
        field,
    }: {
        register: any;
        schema: any;
        designer: any;
        field: BaseField;
    }): any {
        return (
            <AppearanceCheckbox
                label={this.title}
                register={register}
                value={field.rawOptions[this.keyName]}
                placeholder={this.title}
                field={field}
                keyName={this.keyName}
            />
        );
    }

    public sleepValue(value): any {
        return value !== false;
    }

    public wakeValue(value) {
        return value;
    }
}

export const isHiddenInPdf = (field: any): boolean => {
    const value = field?.rawOptions?.hideInPdf ?? field?.options?.hideInPdf;
    return value === true || value === "on" || value === "true";
};
